import { Card, CardContent, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { useLayout } from 'context'
import { createFilesToSign, getConformityLists } from 'controllers/conformity/index'
import { ConformityListDto, ReadyToSendDto, ReadyToSignDto, SentToDOTDto } from 'dtos/conformity'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import ReadyToSendCard from './ReadyToSendCard'
import ReadyToSignCard from './ReadyToSignCard'
import SentToDOTCard from './SentToDOTCard'

export default function Conformity() {
  const layout = useLayout()

  const [isLoadingReadyToSign, setIsLoadingReadyToSign] = useState<boolean>(false)
  const [isLoadingReadyToSend, setIsLoadingReadyToSend] = useState<boolean>(false)
  const [isLoadingSentToDOT, setIsLoadingSentToDOT] = useState<boolean>(false)

  const [readyToSign, setReadyToSign] = useState<ReadyToSignDto[]>([])
  const [readyToSend, setReadyToSend] = useState<ReadyToSendDto[]>([])
  const [sentToDOT, setSentToDOT] = useState<SentToDOTDto[]>([])

  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    layout.setTitle('Conformity')

    setIsLoading(true)
    getConformityLists()
      .then(res => refreshLists(res.value))
      .finally(() => setIsLoading(false))

    return () => {
      layout.setTitle('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    layout.setIsLayoutLoading(isLoading || isLoadingReadyToSign || isLoadingReadyToSend || isLoadingSentToDOT)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading || isLoadingReadyToSign, isLoadingReadyToSend, isLoadingSentToDOT])

  const refreshLists = (conformityLists: ConformityListDto) => {
    if (conformityLists.readyToSign) {
      setReadyToSign(conformityLists.readyToSign)
    }
    if (conformityLists.readyToSend) {
      setReadyToSend(conformityLists.readyToSend)
    }
    if (conformityLists.sentToDOT) {
      setSentToDOT(conformityLists.sentToDOT)
    }
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography fontWeight='bold' variant='h5'>
              Conformity
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <ReadyToSignCard readyToSign={readyToSign} refreshLists={refreshLists} />
      </Grid>

      {/**
       * TODO: Evaluate if Formik is needed here?
       * Maxwell Sommer 2026-07-28
       */}
      <Grid item xs={12}>
        <Formik
          enableReinitialize
          initialValues={[]}
          onSubmit={(values, formikHelpers) => {
            formikHelpers.setSubmitting(true)
            createFilesToSign(values)
              .then(() => {})
              .finally(() => {
                formikHelpers.setSubmitting(false)
              })
          }}
          validateOnBlur
          validateOnChange
        >
          {() => (
            <Form>
              <ReadyToSendCard readyToSend={readyToSend} refreshLists={refreshLists} />
            </Form>
          )}
        </Formik>
      </Grid>

      <Grid item xs={12}>
        <SentToDOTCard sentToDOT={sentToDOT} />
      </Grid>

      <Grid item xs={12}>
        <GreenText variant='outlined'>
          {`**Conformity List Screen:**

Conformity is the process of submitting required documents and photos to the DOT, allowing the DOT to confirm the vehicle conforms with required vehicles standards for the vehicle to be sold in the USA.`}
        </GreenText>
      </Grid>
    </Grid>
  )
}
